import api from './api';

export const virtualNumberService = {
  async getCountries() {
    const response = await api.get('/virtual-numbers/countries');
    return response.data;
  },

  async getServicesByCountry(countryId, params = {}) {
    const response = await api.get(`/virtual-numbers/countries/${countryId}/services`, { params });
    return response.data;
  },

  async purchaseVirtualNumber(serviceCode, countryId) {
    const response = await api.post('/virtual-numbers/purchase', {
      serviceCode,
      countryId
    });
    return response.data;
  },

  async getMyNumbers(status = 'all') {
    const params = {};
    if (status && status !== 'all') {
      params.status = status;
    }
    const response = await api.get('/virtual-numbers/my-numbers', { params });
    return response.data;
  },

  async getSmsCode(purchaseId) {
    const response = await api.get(`/virtual-numbers/${purchaseId}/code`);
    return response.data;
  },

  async cancelVirtualNumber(purchaseId) {
    const response = await api.post(`/virtual-numbers/${purchaseId}/cancel`);
    return response.data;
  }
};
